import CryptoJS from "crypto-js";

const getDecryptedData = (data, password) => { 
  if (!data) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(data, password);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

        return decrypted ? JSON.parse(decrypted) : null;
  }catch(error) {
    return null;
  }
};

export default getDecryptedData;